import Login from "../../../../jsx/pages/Agent/Login";

const LoginWrapper = function (props) {
  return <Login />;
};

export default constore(LoginWrapper);
